import { Container } from '@cp/ds/src/components/container';
import { StyledListItem } from '@cp/ds/src/components/styled/styledListItem';
import { Typography } from '@cp/ds/src/components/typography';
import React from 'react';
import { usePathGenerator } from '@cp/entities/clientWebRoutes';
import { RoutedLink as Link } from 'src/shared/ui/link';
import { ClientWebPage } from '../../../../../../../common/model/meta/clientWebPage';

export const FeedbacksRules = () => {
  const generateAppPath = usePathGenerator();
  return (
    <Container sx={{ mb: { xs: 4, md: 8 } }}>
      <Typography component="h2" sx={{ typography: { xs: 'h4', md: 'h2' }, m: 0, mb: { xs: 2.75 } }}>
        Рекомендации и правила публикации отзывов
      </Typography>
      <Typography component="p" sx={{ my: 2 }}>
        Чтобы на сервисе YouHelp присутствовали только полезные отзывы, мы сформулировали правила их написания. Несоблюдение данных правил
        может стать причиной снижения личного рейтинга и привести к удалению отзыва. Вы можете{' '}
        <Link href={generateAppPath({ page: ClientWebPage.WriteToDirector })}>пожаловаться</Link> на любой отзыв, нарушающий правила. Все
        жалобы проверяются модераторами.
      </Typography>
      <Typography component="h3" sx={{ typography: { xs: 'h6', md: 'h3' }, m: 0, mb: { xs: 2.5 } }}>
        Рекомендации для авторов отзывов
      </Typography>
      Чтобы отзыв был полезным, придерживайтесь следующих рекомендаций:
      <Typography component="ul" sx={{ my: 2 }}>
        <StyledListItem sx={{ ml: -2.75 }}>
          <b>1. Больше деталей</b>
        </StyledListItem>
        Пишите подробно, что именно Вам понравилось, а что нет. Это поможет нанимателям сделать выбор, а организациям исправить недочеты.
        <StyledListItem sx={{ ml: -2.75 }}>
          <b>2. Пишите просто и понятно</b>
        </StyledListItem>
        При написании важно ориентироваться на простую публику обывателей. Не стоит употреблять сложные обороты и выражения.
        <StyledListItem sx={{ ml: -2.75 }}>
          <b>3. Пишите вежливо</b>
        </StyledListItem>
        Не стоит применять грубые слова и нецензурные выражения, так как это может оскорбить читателей. Любое недовольство следует выражать
        мягко и без агрессии, избегая ругательств.
        <StyledListItem sx={{ ml: -2.75 }}>
          <b>4. Пишите грамотно и лаконично</b>
        </StyledListItem>
        Пишите на грамотном русском языке. Не используйте транслитерацию. Не злоупотребляйте заглавными буквами, восклицательными знаками,
        смайлами и эмодзи. Не пишите отзыв в стихах, не используйте стилизаций, затрудняющих понимание. Это не сделает ваш отзыв более
        заметным, а лишь вызовет раздражение.
        <StyledListItem sx={{ ml: -2.75 }}>
          <b>5. Пишите о настоящем</b>
        </StyledListItem>
        Составлять отзывы следует на основе реальных фактов, которые произошли недавно. Информация многолетней давности только введет
        читателя в заблуждение. Сообщение должно помогать делать правильный выбор и не сомневаться в решении.{' '}
      </Typography>
      <Typography component="h3" sx={{ typography: { xs: 'h6', md: 'h3' }, m: 0, mb: { xs: 2.5 } }}>
        Правила публикации отзывов
      </Typography>
      <Typography component="p" sx={{ my: 2 }}>
        Пользователь может оставить только один отзыв на организацию и в дальнейшем редактировать его. К этому отзыву можно добавить
        комментарии. Отзыв и комментарии должны быть написаны в кириллической раскладке на русском языке. И отзывы, и комментарии мы
        проверяем на соответствие требованиям. Проверка может занять несколько часов.
      </Typography>
      <Typography component="h3" sx={{ typography: { xs: 'h6', md: 'h3' }, m: 0, mb: { xs: 2.5 }, color: 'brand pink' }}>
        <b>Требования к отзывам</b>
      </Typography>
      Чтобы текст прошел модерацию и был опубликован, необходимо ориентироваться на следующие правила:
      <Typography component="ul" sx={{ my: 2 }}>
        <StyledListItem sx={{ ml: -2.75 }}>
          <b>1. Описывайте личный опыт</b>
        </StyledListItem>
        Главное в отзыве — это ваш личный опыт, впечатления и эмоции, которые помогут другим пользователям сделать свой выбор.
        <StyledListItem sx={{ ml: -2.75 }}>
          <b>2. Не используйте отзывы как чат</b>
        </StyledListItem>
        Обращения или вопросы к другим пользователям с целью вступить с ними в дискуссию через отзывы - запрещены.
        <StyledListItem sx={{ ml: -2.75 }}>
          <b>3. Не пишите дважды об одном и том же</b>
        </StyledListItem>
        Об одном объекте оставляйте один отзыв. Если ваше мнение изменилось, просто отредактируйте отзыв.
        <StyledListItem sx={{ ml: -2.75 }}>
          <b>4. Избегайте рекламы</b>
        </StyledListItem>
        Отзывы, содержащие призыв к чему-либо и рекламу, удаляются. Попытка массового распространения через отзывы любых, в том числе,
        рекламных текстов, может привести к блокировке аккаунта.
        <StyledListItem sx={{ ml: -2.75 }}>
          <b>5. Без личных данных</b>
        </StyledListItem>
        Не указывайте в отзывах детальную личную информацию о других людях (контактные данные, домашний адрес и т. п.).
        <StyledListItem sx={{ ml: -2.75 }}>
          <b>6. Без дискриминации</b>
        </StyledListItem>
        Не используйте слова, фразы или изображения, которые можно расценить как дискриминацию по любым признакам (политическим,
        религиозным, этническим и т. д.).
        <StyledListItem sx={{ ml: -2.75 }}>
          <b>7. Воздерживайтесь от жесткости и грубых подробностей</b>
        </StyledListItem>
        Не публикуйте тексты и изображения, которые способны вызвать сильные отрицательные чувства: ужас, панику, отвращение. Такие отзывы в
        большинстве случаев вызывают отрицательные эмоции со стороны читателей.
        <StyledListItem sx={{ ml: -2.75 }}>
          <b>8. Не публикуйте контент для взрослых</b>
        </StyledListItem>
        Размещение эротического или порнографического материала недопустимо. Это может привести не только к блокировке отзыва или аккаунта,
        но и к ответственности.
        <StyledListItem sx={{ ml: -2.75 }}>
          <b>9. Соблюдайте законы</b>
        </StyledListItem>
        Размещенная информация должна соответствовать законодательству России. Избегайте размещения информации о наркотических средствах,
        оружии и иных запрещенных товарах и услугах.
        <StyledListItem sx={{ ml: -2.75 }}>
          <b>10. Не пишите об ошибках</b>
        </StyledListItem>
        Сообщения адресованные команде сервиса YouHelp с сообщением об ошибке в данных будут удалены без передачи в отдел разработки.
      </Typography>
      <Typography component="h2" sx={{ typography: { xs: 'h4', md: 'h2' }, mb: { xs: 2.75 } }}>
        Управление отзывами
      </Typography>
      <Typography component="p" sx={{ my: 2 }}>
        Отзыв – это мнение пользователя о специалисте и его работе, сложившееся после ее выполнения. Отзыв может сопровождаться оценкой по
        пятибалльной шкале. На основании отзывов пользователей рассчитывается рейтинг специалиста — агрегированная оценка качества работы и
        популярности. Чем выше рейтинг, тем более привлекательна анкета специалиста для клиентов.
      </Typography>
      <Typography component="p" sx={{ my: 2 }}>
        Рейтинг рассчитывается автоматически с использованием алгоритмов машинного обучения. Чем больше отзывов и оценок оставляют
        пользователи, тем точнее становится результат расчета. Алгоритм расчета рейтинга настроен так, чтобы отслеживать и предотвращать
        публикацию сомнительных и необоснованно негативных отзывов. В расчете рейтинга участвуют оценки, оставленные только пользователями
        YouHelp.
      </Typography>
      Заказчик может:
      <Typography component="ul" sx={{ my: 2 }}>
        <StyledListItem>- прокомментировать любой отзыв;</StyledListItem>
        <StyledListItem>- изменить или удалить свой отзыв или комментарий;</StyledListItem>
        <StyledListItem>- оставить отзыв о сайте организации. </StyledListItem>
      </Typography>
      Специалист может:
      <Typography component="ul" sx={{ my: 2 }}>
        <StyledListItem>- проводить акции по сбору отзывов клиентов;</StyledListItem>
        <StyledListItem>- настроить получение уведомлений об отзывах на почту;</StyledListItem>
        <StyledListItem>- ответить на отзыв или комментарий, изменить свой ответ или удалить его;</StyledListItem>
        <StyledListItem>
          - <Link href={generateAppPath({ page: ClientWebPage.WriteToDirector })}>пожаловаться</Link> на некорректный отзыв или комментарий.
        </StyledListItem>
      </Typography>
      <Typography component="h2" sx={{ typography: { xs: 'h4', md: 'h2' }, mb: { xs: 2.75 } }}>
        Как отредактировать отзыв
      </Typography>
      <Typography component="p" sx={{ my: 2 }}>
        Изменить или удалить свой отзыв либо комментарий вы можете на странице специалиста.
      </Typography>
      <Typography component="ul" sx={{ my: 2 }}>
        <StyledListItem>1. Войдите в тот аккаунт на YouHelp, под которым вы оставляли отзыв или комментарий.</StyledListItem>
        <StyledListItem>2. Найдите нужного Вам специалиста на YouHelp.</StyledListItem>
        <StyledListItem>3. Найдите свой отзыв или комментарий в списке. Отредактируйте или удалите его.</StyledListItem>
      </Typography>
      <Typography component="h2" sx={{ typography: { xs: 'h4', md: 'h2' }, mb: { xs: 2.75 } }}>
        Как ответить или пожаловаться на отзыв
      </Typography>
      <Typography component="h3" sx={{ typography: { xs: 'h6', md: 'h3' }, m: 0, mb: { xs: 2.5 } }}>
        Положительные отзывы:
      </Typography>
      <Typography component="p" sx={{ my: 2 }}>
        Специалист может прокомментировать только отзывы, оставленные пользователями YouHelp. Благодарите пользователей и отвечайте на
        вопросы в отзывах, чтобы показать участливость и небезразличие.
      </Typography>
      Чтобы дать ответ на отзыв или комментарий:
      <Typography component="ul" sx={{ my: 2 }}>
        <StyledListItem>1. Перейдите на страницу анкеты.</StyledListItem>
        <StyledListItem>2. Долистайте до отзыва.</StyledListItem>
        <StyledListItem>3. Нажмите кнопку Ответить.</StyledListItem>
      </Typography>
      Вы также можете изменить или удалить комментарий. Для этого:
      <Typography component="ul" sx={{ my: 2 }}>
        <StyledListItem>1. Найдите нужный отзыв и комментарии.</StyledListItem>
        <StyledListItem>2. Выберите действие: Редактировать комментарий или Удалить комментарий.</StyledListItem>
      </Typography>
      <Typography component="p" sx={{ my: 2 }}>
        В течение трех дней изменения будут опубликованы в карточке организации.
      </Typography>
      <Typography component="h2" sx={{ typography: { xs: 'h4', md: 'h2' }, mb: { xs: 2.75 } }}>
        Почему исчезли отзывы
      </Typography>
      Отзывы на организацию могут пропасть по следующим причинам:
      <Typography component="ul" sx={{ my: 2 }}>
        <Typography component="li">специалист удалил свою анкету;</Typography>
        <Typography component="li">
          отзыв снят с публикации по результатам дополнительной проверки на соответствие{' '}
          <Link href={generateAppPath({ page: ClientWebPage.UserAgreement })}>нашим правилам</Link> или иным{' '}
          <Link href={generateAppPath({ page: ClientWebPage.PrivacyPolicy })}>правилам, установленным YouHelp.</Link>
        </Typography>
      </Typography>
    </Container>
  );
};
